import React from 'react';
import { createRoot } from 'react-dom/client';

import RouterComponent from './RouterComponent';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';

document.title = 'Router debug';

createRoot(document.getElementById('app')!).render(<RouterComponent />);
